<template>
<div class="container">
    <div id="slider">
        <!-- 写死的值，可以直接用height，interval，如果是双向绑定的需要写   v-bind:height -->
        <slider animation="fade" height='456px'>
            <p style="line-height: 280px; font-size: 5rem; text-align: center;" v-if="!list.length">Loading...</p>
            <slider-item v-for="(item, index) in list" :key="index" @click="tobook(index)">
                <div class="wrap">
                    <img :src="item.bannerImg | objs">
                </div>
            </slider-item>
        </slider>
    </div>
    <div class="container">
        <ul class="typelink">
            <div v-for="(item,index) in typeLink" :key="index">
                <li @click="totype(item.id)" ><img :src="item.newUrl | objs" /> <p>{{item.name}}</p></li>
            </div>
            <li @click="totype(-1)"><img src="https://objs.auto-learning.com/xcximages/home_btn_gd3x.png" /> <p>更多</p></li>
        </ul>
    </div> 
</div>
</template>

<script> 
import {
    Slider,
    SliderItem
} from 'vue-easy-slider'

export default {
    name: 'banner',
    data() {
        return {
            list: [],
            typeLink:[]
        }
    },
    methods: {
        tobook(index) {
            if (this.list[index].type == 1) {
                this.$router.push({
                    path: '/bookdetail?bookId=' + this.list[index].bookModel.bookId
                })
            } else if (this.list[index].type == 2) {
                this.$router.push({
                    path: '/booklist?listId=' + this.list[index].bookListModel.listId
                })
            }else if (this.list[index].type == 3) {
                window.location.href=this.list[index].h5Model.h5
            } else if (this.list[index].type == 4) {
                this.$router.push({
                    path: '/booklist?listId=' + this.list[index].bookListModel.listId
                })
            } else {
                console.log('没有这个类型')
            }

        },
        totype: function (atype) { 
           this.$router.push({path:'/library?id='+atype})
        }
    },
    mounted() {
        this.$http.get({
            url: 'xcx/banner-list'
        }).then(res => {
			const {data} = res.data 
			const list = []
			data.forEach(item => {
				if(item.id !== 66) {
					list.push(item)
				}
			})
            this.list = list; // res.data.data; 
        })

    this.$http.get({
            url: 'xcx/type-link?pageSize=9'
        }).then(res => {
            this.typeLink = res.data.data; 
        })
    },
    components: {
        'Slider': Slider,
        'SliderItem': SliderItem
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
#slider{margin-top: 30px;} 
.bottomheight{height: 100px;}
img {
    width: 100%;
    /*height: 336px;*/
}

.wrap {
    text-align: center
}

.wrap img {
    cursor: pointer;
}
.typelink{list-style: none; padding: 30px 0 30px 0;}
.typelink li{width: 10%; float: left; text-align: center;}
.typelink li img{width: 30%; clear: both;}
.typelink li p{ 
font-size: 16px;
font-family: PingFang SC;
font-weight: 400;
color: #444A47;
margin: 5px;
}
</style>
